import { render, staticRenderFns } from "./BottomRightTable1.vue?vue&type=template&id=516147a4&"
import script from "./BottomRightTable1.vue?vue&type=script&lang=js&"
export * from "./BottomRightTable1.vue?vue&type=script&lang=js&"
import style0 from "./BottomRightTable1.vue?vue&type=style&index=0&id=516147a4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports